import { DatePipe } from "@angular/common";
import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef, HostListener } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbPopoverConfig, NgbPopover, NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { CsAgentAuthService } from "@spartacus/asm/root";
// import { ActiveCartService } from "@spartacus/cart/base/core";
import { RoutingService, OccEndpointsService, GlobalMessageService, CmsService, AuthService, BaseSiteService, GlobalMessageType } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { enGbLocale, defineLocale } from "ngx-bootstrap/chronos";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { CustomAddToCartService } from "src/app/custom-add-to-cart/custom-add-to-cart.service";
import { ProductDetailsComponent } from "src/app/custom-add-to-cart/custom-add-to-cart/product-details/product-details.component";
import { CustomProdPgService } from "src/app/custom-prod-pg/custom-prod-pg.service";
import { SharedService } from "src/app/shared/services/shared.service";
import { ProductUtils } from "src/app/shared/utils/productUtils";
import * as _ from 'underscore';
import {otherDiscounts, saleTax} from '../../shared/utils/constants/global.constants';
import * as moment from 'moment';

@Component({
  selector: 'app-checkout-confirm',
  templateUrl: './checkout-confirm.component.html',
  styleUrls: ['./checkout-confirm.component.scss']
})
export class CheckoutConfirmComponent implements OnInit, OnDestroy {
  deliveryPickup: string = 'delivery';
  headerLevelObj: any;
  isSticky: boolean = false;
  cMethodVal: boolean = true;
  showonHold: boolean = false;
  public productInfo: {
    available: boolean;
    availabilityText: string;
    batchInfo: {
      batchNumber: string;
      expiryDate: string;
      quantity: number;
    };
    images: any;
    code: string;
    description: string;
    discontinued: boolean;
    sapAllocation: boolean;
    displayProduct: boolean;
    flu: boolean;
    nameHtml: any;
    summary: any;

    productUpdate: string;
    productDocuments: {
      productDocument: [
        {
          url: string;
        }
      ];
    };
    name: string;
    orderable: boolean;
    quantityPerUnit: number;
    productUpdates: string;
    productDocument: any;
    volumePrices: [
      {
        currencyIso: string;
        formattedValue: string;
        maxQuantity: string;
        minQuantity: string;
        priceType: string;
        value: string;
      }
    ];
    url: string;
    stock: {
      isValueRounded: boolean;
    };
    isValueRounded: boolean;
    yellowFever: boolean;
    volumePricesFlag: boolean;
  } = null;
  standardCartDetails: any;
  productEntries: any = [];
  public images: any;
  updateTotal: boolean;
  updateEntriesData: any = [];
  subTotal: number;
  baseUrl: string;
  showphoneNo: boolean = false;
  showmobileNo: boolean = false;
  minDeliveryDate = new Date();
  maxDeliveryDate = new Date();
  minPickupDate = new Date();
  maxPickupDate = new Date();
  currentTime = new Date().getHours();
  pickupTimeFormat: any = [];
  timeFormat: any;
  selectedTime: any;
  deliveryDate: Date;
  deliveryCrossIcon: boolean;
  pickupDate: Date;
  deliveryDateFormat: string;
  pickupDateFormat: string;
  pickupCrossIcon: boolean;
  fallbackImage = '../../assets/i18n-assets/sanofi_missing_product.jpg';
  closeResult = '';
  usergetDataObj: any;
  getuserData: any;
  searchedClientList: any;
  selectedData: any;
  listSelectedData: any;
  userAccountgetData: any;
  saveCartName: string;
  popoverConfig: NgbPopoverConfig;
  cartId: any;
  errorMsg: string;
  deleteSuccess: string;
  addSuccess = false;
  cartItems: any;
  totalSavings = 0.00;
  subTotalVal = 0.00;
  changeLocation = false;
  templatePage: any;
  prodAddedSub: Subscription;
  cartItemsSub: Subscription;
  removeEntriesSub: Subscription;
  deleteCartSub: Subscription;
  cartDetailsSub: Subscription;
  checkoutDetailsSub: Subscription;
  checkoutFailedSub: Subscription;
  userAccountDetailsSub: Subscription;
  changedLocSub: Subscription;
  saveCartInvalidSub: Subscription;
  saveCartSuccessSub: Subscription;
  plpMiniCartSub: Subscription;
  userDataSub: Subscription;
  emailArr = [{ id: null, value: '' }];
  emailList = [{ id: '1', value: 'test@12.com' }, { id: '2', value: 'test@1234562.com' }];
  mobileList = [''];
  noshowaddmobile: boolean = false;
  noshowaddemail: boolean = false;
  @ViewChild('p2') public savePopover: NgbPopover;
  orderBlock = false;
  showDangerAlert = false;
  checkoutClicked = false;
  checkoutCartClicked = false;
  yfEntry = false;
  urlPath: string;
  localSubscription: any;
  panelProductExpanded2 = false;
  panelProductExpanded = true;
  b2bUnitId: any;
  cartProdDetails: Subscription;
  expandedItems: boolean[] = [];
  stdCartDetails: any = [];
  orderContactDetails: any;
  payerAddress: any;
  checkoutCartDetailsSub: Subscription;
  checkoutCartFailedSub: Subscription;
  baseSiteId: any;
  shippingAddressOfLocation: any;
  isFutershipAdded = false;
  isAsmUser: boolean = false;
  csAgentAuthSubscription: Subscription;
  cardDetails: string;
  warningImage: string;
  punchOutKey: boolean;
  otherDiscountsFlag: string;
  salesTaxFlag: string;
  // influenzaOrderPo: boolean;
  //After upgrade ActiveCartService causing - NullInjectorError: R3InjectorError(AppModule)[ActiveCartService -> ActiveCartService -> ActiveCartService]
  constructor(
    protected modal: NgbModal,
    // private readonly getCart: ActiveCartService,
    private readonly cdr: ChangeDetectorRef,
    private readonly addToCart: CustomAddToCartService,
    readonly user: UserAccountFacade,
    private readonly modalService: NgbModal,
    private localeService: BsLocaleService,
    public datepipe: DatePipe,
    private readonly config: NgbPopoverConfig,
    private readonly route: RoutingService,
    private readonly occEndPoint: OccEndpointsService,
    private readonly plpService: CustomProdPgService,
    private globalMessage: GlobalMessageService,
    private readonly pageDate: CmsService,
    private readonly sharedService: SharedService,
    private readonly routeService: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly csAgentAuthService: CsAgentAuthService,
    private baseSiteService: BaseSiteService
  ) {
    this.images = {};
    this.updateTotal = false;
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('en-gb', enGbLocale);
    this.localeService.use('en-gb');
    this.pickupTimeFormat = [
      '09:00 am',
      '10:00 am',
      '11:00 am',
      '12:00 pm',
      '01:00 pm',
      '02:00 pm',
      '03:00 pm',
      '04:00 pm',
      '05:00 pm',
    ];
    this.selectedTime = null;
    config.autoClose = 'outside';
    this.deleteSuccess = '';
    this.addSuccess = false;
  }
  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    if (window.pageYOffset >= 150) {
      this.isSticky = true;
    } else {
      this.isSticky = false;
    }
  }

  ngOnInit(): void {
    this.otherDiscountsFlag = otherDiscounts;
    this.salesTaxFlag = saleTax;
    if (localStorage.getItem('punchout-sid-key') != null) {
      this.punchOutKey = true;
    }
    this.csAgentAuthSubscription = this.csAgentAuthService.isCustomerEmulated().subscribe((res) => {
      this.isAsmUser = res ? res : false;
    });
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.localSubscription = this.authService
      .isUserLoggedIn()
      .subscribe((res) => {
        if (sessionStorage.getItem('counter') == null) {
          sessionStorage.setItem('counter', '1');
        } else {
          let temp = Number(sessionStorage.getItem('counter'));
          temp = temp + 1;
          sessionStorage.setItem('counter', String(temp));
        }
      });
    this.authService.logoutInProgress$.subscribe((res) => {
      if (res) {
        this.authService.isUserLoggedIn().subscribe((res) => {
          if (!res) {
            sessionStorage.removeItem('counter');
          }
        });
      }
    });

    this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
    this.plpMiniCartSub = this.plpService.getUpdateMiniCart().subscribe((res) => {
      if (res) {
        this.addToCart.removedEntries(res, this.userAccountgetData?.uid);
        this.removeEntriesMapping();
      }
    });
    this.plpService.stdCartMsg.next(false);
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
    this.pageDate.getCurrentPage().subscribe((res) => {
      if (res) {
        this.templatePage = res?.template;
      }
    });
    this.userDataSub = this.user.get().subscribe((res) => {
      if (res && res != null) {
        this.userAccountgetData = res;
        this.getUserAccountData(this.userAccountgetData.uid);
        this.productEntries = [];
        this.getCartDetails();
        this.cdr.detectChanges();
      }
    });
    this.prodAddedSub = this.plpService.stdCartMsg$.subscribe((res) => {
      if (res) {
        this.addSuccess = true;
        this.deleteSuccess = '';
        this.plpService.stdCartMsg.next(false);
      }
    });
    this.setDeliveryDate();
    this.setPickupDate();
    setTimeout(() => {
      if ('productAllocations' in sessionStorage) 
      {
        this.sharedService.fetchProductAllocations(JSON.parse(localStorage.getItem('userId')), JSON.parse(localStorage.getItem('accountId'))).pipe(take(1)).subscribe(prods => {
          this.sharedService.setSessionStorage('productAllocations', prods.hasOwnProperty('productAllocations') ? prods.productAllocations : {});
        });
      }
    }, 3000);
    this.addToCart.weekList = [];
  }
  

  addemail() {
    if (this.emailArr.length <= 3) {
      this.emailArr.push({ id: null, value: '' });
      if (this.emailArr.length == 3) {
        this.noshowaddemail = true;
      }
    }
  }
  addnewEmail(event, emailIndex) {
    if (event.$ngOptionLabel == 'Add new email') {
      this.emailArr[emailIndex].id = ''
      this.emailArr[emailIndex].value = ''
    } else {
      this.emailArr[emailIndex].id = event
    }
  }
  addMobile() {
    if (this.mobileList.length <= 3) {
      this.mobileList.push('1');
      if (this.mobileList.length == 3) {
        this.noshowaddmobile = true;
      }
    }
  }
  openmodal(content) {
    this.modal.open(content, {
      centered: true,
      backdrop: 'static',
      windowClass: 'locStripModal'
    });
  }
  getCartDetails() {
    this.addToCart.placeOrder.subscribe((res: any) => {
      if (res) {
        if (res.orders[0].hasOwnProperty("placeOrderMessage") && res?.orders[0].placeOrderMessage == 'Error while payment authorization during place order.') {
          this.globalMessage.add('Error while payment authorization during place order.', GlobalMessageType.MSG_TYPE_ERROR);
          setTimeout(() => {
            this.route.goByUrl("/cart");
          }, 2000);
        }
        else {
          this.cartDataMapping(res);
        }
      }
    });
    if (this.cartId && this.templatePage === 'CartPageTemplate') {
      this.addToCart.removedEntries(this.cartId, this.userAccountgetData?.uid);
      this.removeEntriesMapping();
    }
    this.cdr.detectChanges();
  }
  getPOnumber(dt) {
    var ponumber = dt.split(":");
    return ponumber[0];
  }
  getRequestedDate(dt) {
    if (dt) {
      var formatedDate = dt?.split('T');
      var splitDateF = formatedDate[0].split('-');

      var finalFormatedDate =
        splitDateF[1] + '/' + splitDateF[2] + '/' + splitDateF[0];

      return finalFormatedDate;
    }
  }
  getCalculatedValue(firstVal, TaxValue, secondVal, quantity) {
    var total = firstVal + TaxValue * quantity + secondVal;
    return parseFloat(total.toFixed(2));
  }
  removeEntriesMapping() {
    this.removeEntriesSub = this.addToCart.removedItems$.subscribe((res: any) => {
      if (res) {
        let removedData = res?.removedEntries?.cartModifications;
        let stdCartDetails;
        this.yfEntry = false;
        stdCartDetails = res?.childCarts;
        if (stdCartDetails) {
          stdCartDetails = stdCartDetails.filter(
            (item) => item
            //.cartType === 'STANDARD'
          );
          if (stdCartDetails && stdCartDetails?.length > 0) {
            stdCartDetails = Object.assign({}, ...stdCartDetails);
            for (let entries of stdCartDetails?.entries) {
              if (entries?.product?.yellowFever) {
                this.yfEntry = true
              }
            }
          }
        }
        if (!stdCartDetails?.shipToParty?.yellowFeverFlag && this.yfEntry) {
          this.yfEntry = true;
        } else {
          this.yfEntry = false;
          this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
        }
        if (removedData && removedData?.length > 0) {
          for (const data of removedData) {
            if (!stdCartDetails?.shipToParty?.yellowFeverFlag && this.yfEntry) {
              this.globalMessage.add(data.statusMessage,
                GlobalMessageType.MSG_TYPE_ERROR, 5000000
              );
            } else {
              this.globalMessage.add(data.statusMessage,
                GlobalMessageType.MSG_TYPE_ERROR
              );
            }
          }
        }
        this.addToCart.getAllCarts(this.userAccountgetData?.uid);
        this.addToCart.removedItems.next(false);
      }
    });
  }

  stdFluDesc(productentry) {
    // return (productentry?.product?.variantOptions.length > 0 && productentry?.product?.variantOptions[0]?.flu &&
    //   productentry?.product?.variantOptions[0]?.shipNow == 'ON') || (productentry?.product?.variantOptions.length == 0 &&
    //     productentry?.product?.flu && productentry?.product?.shipNow == 'ON') ? 'Influenza Vaccine' : productentry?.product?.description
    return productentry?.product?.description;
  }

  deleteEmail(i) {
    this.emailArr.splice(i, 1)
    if (this.emailArr.length < 3) {
      this.noshowaddemail = false;
    }
  }
  cMethodElection(method) {
    if (method == 'fax') {
      this.cMethodVal = false;
    }
    else {
      this.cMethodVal = true;
    }

  }
  deleteMobile(i) {
    this.mobileList.splice(i, 1)
    if (this.mobileList.length < 3) {
      this.noshowaddmobile = false;
    }
  }
  cartDataMapping(data): void {
    //let stdCartDetails = [];
    this.stdCartDetails = [];
    this.productEntries = [];
    //this.headerLevelObj = data?.orders[0];
    this.cartId = data?.orders[0].code;
    this.stdCartDetails = data;
    this.headerLevelObj = this.stdCartDetails?.orders.filter((el) => el.hidePriceForTotals);
    this.saveCartName =
      JSON.parse(sessionStorage.getItem('selectedLocations'))?.length <= 1
        ? this.stdCartDetails?.orders[0]?.shipToLoc_name
        : '';
    if (this.stdCartDetails.orders[0]?.hasOwnProperty("paymentInfo")) {
      var last4Digit = this.stdCartDetails.orders[0]?.paymentInfo?.cardNumber?.split("-");
      //this.cardDetails = this.stdCartDetails.orders[0]?.paymentInfo?.cardType?.code != undefined ? this.stdCartDetails.orders[0]?.paymentInfo?.cardType?.code + " ending with " + last4Digit[2] : "ending with " + last4Digit[2];
      this.cardDetails = this.stdCartDetails.orders[0]?.paymentMethod == 'Pay by card immediately' ? this.stdCartDetails.orders[0]?.paymentInfo?.cardType?.code + " ending in " + last4Digit[2] : "Account ending in " + last4Digit[2];
    }

    if (this.stdCartDetails.orders[0]?.hasOwnProperty("approver")) {
      this.showonHold = true;
      this.warningImage = `${this.baseUrl}` + "/warning_red_new.png";
    }

    // this.stdCartDetails.orders[0].orderContactData.salesRepEmail = 'asagent@sanofi.com'; //hardcoded for testing

    this.orderContactDetails = this.stdCartDetails.orders[0]?.shipToParty?.billingAddress;
    this.payerAddress = this.stdCartDetails.orders[0]?.shipToParty?.payerAddress;
    this.selectedData = this.stdCartDetails.orders[0]?.shipToParty;

    if (this.stdCartDetails?.orders?.length > 1) {
      this.selectedData.name = '';
    }

    //15032-Below logic is only considering single location. for multiple location, logic is moved inside loop below
    // if (this.stdCartDetails.orders[0]?.shipToParty) {
    //   this.shippingAddressOfLocation = this.stdCartDetails.orders[0]?.shipToParty?.shippingAddresses.filter((item) => item.accountNumber === this.stdCartDetails.orders[0]?.shipToParty.uid);
    //   this.shippingAddressOfLocation = _.first(this.shippingAddressOfLocation);
    // }
    // else {
    //   this.shippingAddressOfLocation = this.stdCartDetails.orders[0]?.shippingAddress;
    // }

    if (this.stdCartDetails?.orders[0]?.orderContactData.hasOwnProperty("phoneNo") && this.stdCartDetails?.orders[0]?.orderContactData.phoneNo != '') {
      this.showphoneNo = true;
    }
    else {
      this.showphoneNo = false;
    }
    if (this.stdCartDetails?.orders[0]?.orderContactData.hasOwnProperty("mobileNo") && this.stdCartDetails?.orders[0]?.orderContactData.mobileNo != '') {
      this.showmobileNo = true;
    }
    else {
      this.showmobileNo = false;
    }
    this.totalSavings = 0;
    this.subTotalVal = 0;
    this.stdCartDetails.orders.forEach(el => {
      // this.totalSavings += el.totalDiscounts.value;
      // this.subTotalVal += (ele.totalPrice.value + ele.exciseTax.value * ele.quantity);
      // if (el?.futureShipExpProd && el?.splitEntriesDeliveryDates?.length > 0)
      //   this.isFutershipAdded = true;

      //For ship-to address of each location
      if (el?.shipToParty) {
        el.shippingAddressOfLocation = el?.shipToParty?.shippingAddresses.filter((item) => item?.accountNumber === el?.shipToParty?.uid);
        el.shippingAddressOfLocation = _.first(el?.shippingAddressOfLocation);
      }
      else {
        el.shippingAddressOfLocation = el?.shippingAddress;
      }
      this.totalSavings = this.totalSavings + el.totalDiscounts.value;
      this.subTotalVal = this.subTotalVal + el.totalPrice.value;
      el.entries.forEach(item => {
        if (item?.futureShipExpProd && item?.splitEntriesDeliveryDates?.length > 0)
          this.isFutershipAdded = true;
      })
    })
    this.cdr.detectChanges();
    // this.subTotalVal = this.subTotalVal + this.totalSavings;
    // this.subTotalVal = parseFloat(this.subTotalVal.toFixed(2));
    // this.totalSavings = parseFloat(this.totalSavings.toFixed(2));
  }

  performQuantityComputation(
    operator,
    idData,
    quantityOfUnits = 1,
    entryNumber,
    childIndex
  ): void {
    const updatedData = String(idData) + '-' + String(childIndex);

    ProductUtils.alterQuantity(operator, updatedData, quantityOfUnits);
    this.updateTotal = true;
    const inputElement = document.getElementById(
      `prodQuantity${updatedData}`
    ) as HTMLInputElement;
    const params = { entryNumber: entryNumber, quantity: inputElement.value };
    if (
      this.updateEntriesData.some(
        ({ entryNumber }) => entryNumber === params.entryNumber
      )
    ) {
      this.updateEntriesData[
        this.updateEntriesData.findIndex(
          (el) => el.entryNumber === params.entryNumber
        )
      ] = params;
    } else {
      this.updateEntriesData = [...this.updateEntriesData, params];
    }
  }
  deleteCart(entryNumber, prodName, childCartIndex): void {
    this.addToCart.deleteCartItem(entryNumber, this.stdCartDetails[childCartIndex].code, this.cartId);
    this.deleteCartSub = this.addToCart.deleteItems$.subscribe((res) => {
      if (res) {
        this.addToCart.deleteItems.next(false);
        this.addToCart.removedEntries(this.cartId, this.userAccountgetData?.uid);
        this.removeEntriesMapping();
        this.deleteSuccess = prodName;
        this.addSuccess = false;
      }
    });
  }
  closeAlert() {
    this.deleteSuccess = '';
    this.addSuccess = false;
  }
  closeDangerAlert() {
    this.showDangerAlert = false;
  }
  clearChildCart(): void {
    this.addToCart.clearCart(this.standardCartDetails.code);
  }
  openPopover(popover) {
    popover.open();
  }
  toggleClose() {
    if (this.savePopover) {
      this.savePopover.close();
    }
  }
  toggle(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
    this.errorMsg = "";
    //this.saveCartName = this.selectedData?.name?.slice(0, 30);
  }
  updateCart(): void {
    this.addToCart.updateCartDetails(this.standardCartDetails.code, this.updateEntriesData, this.cartId);
    this.cartDetailsSub = this.addToCart.cartDetails$.subscribe((res: any) => {
      if (res) {
        this.updateTotal = false;
        let stdCartDetails = [];
        stdCartDetails = res?.childCarts;
        stdCartDetails = stdCartDetails.filter(
          (item) => item
          //.cartType === 'STANDARD'
        );
        this.standardCartDetails = Object.assign({}, ...stdCartDetails);
        this.updateEntriesData = [];
      }
      this.cdr.detectChanges();
    });
  }
  productDetails(productDetails, i): void {
    const modalRef = this.modalService.open(ProductDetailsComponent, {
      windowClass: `product-details-modal ${this.baseSiteId}`
    });
    modalRef.componentInstance.productDetails = productDetails;
    modalRef.componentInstance.standardCartCode = this.stdCartDetails.orders[i].code;
    // modalRef.componentInstance.unitSection = 'Update';
    modalRef.componentInstance.unitSection = 'NoUnitsCheckout';
  }

  onDeliveryDateChange(value: Date): void {
    if (value) {
      this.deliveryCrossIcon = true;
      this.deliveryDateFormat = this.datepipe.transform(value, 'yyyy-MM-dd');
    } else {
      this.deliveryCrossIcon = false;
    }
  }
  onPickupDateChange(value: Date): void {
    if (value) {
      this.pickupCrossIcon = true;
      this.pickupDateFormat = this.datepipe.transform(value, 'yyyy-MM-dd');
      if (value.getDate() !== this.minPickupDate.getDate()) {
        this.timeFormat = this.pickupTimeFormat;
        this.selectedTime = _.first(this.timeFormat);
      } else {
        this.setPickupTime();
      }
    } else {
      this.pickupCrossIcon = false;
    }
  }
  clearDate(dpDate): void {
    if (dpDate === 'Delivery') {
      this.deliveryDate = null;
      this.deliveryCrossIcon = false;
    } else {
      this.pickupDate = null;
      this.pickupCrossIcon = false;
      this.selectedTime = null;
    }
  }
  redirectToCheckout(): void {
    this.route.goByUrl('/checkout');
  }

  proceedtoFinal() {
    this.modal.dismissAll();
    this.route.goByUrl('/waitlist');
  }
  proceedToCheckout(): void {
    if (
      this.deliveryDateFormat ||
      (this.pickupDateFormat && this.selectedTime)
    ) {
      const params = {
        customerId: this.usergetDataObj.uid,
        date:
          this.deliveryPickup === 'delivery' &&
            (this.deliveryDateFormat || this.pickupDateFormat)
            ? this.deliveryDateFormat
            : this.pickupDateFormat,
        deliveryMode:
          this.deliveryPickup === 'delivery' ? 'standard' : 'pickup',
        pickupTime:
          this.deliveryPickup === 'pickup' && this.selectedTime
            ? this.selectedTime
            : '',
        shipToUnitId: this.selectedData?.uid,
        standard: true,
      };
      this.addToCart.checkoutCart(params, this.cartId);
      this.checkoutClicked = true;
      this.checkoutDetailsSub = this.addToCart.checkoutDetails$.subscribe((res) => {
        if (res) {
          this.checkoutClicked = false;
          this.route.goByUrl('/checkout');
        }
      });
      this.checkoutFailedSub = this.addToCart.checkoutFailed$.subscribe((res) => {
        if (res) {
          this.checkoutClicked = false;
        }
      });
    }
  }

  proceedToCheckoutPage() {
    const params = {
      "b2bUnitId": this.b2bUnitId
    }
    this.addToCart.checkoutCartPage(params, this.cartId);
    this.checkoutCartClicked = true;
    this.checkoutCartDetailsSub = this.addToCart.checkoutCartDetails$.subscribe((res) => {
      if (res) {
        this.checkoutCartClicked = false;
        this.route.goByUrl('/checkout');
      }
    });
    this.checkoutCartFailedSub = this.addToCart.checkoutCartFailed$.subscribe((res) => {
      if (res) {
        this.checkoutCartClicked = false;
      }
    });
  }

  open(content): void {
    this.searchedClientList = this.getuserData;
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getUserAccountData(userId): void {
    this.userAccountDetailsSub = this.addToCart.userAccountDetails$.subscribe((userDataget) => {
      if (userDataget) {
        this.usergetDataObj = userDataget.res;
        this.getuserData = userDataget.res.shippingAddresses;
        this.searchedClientList = userDataget.res.shippingAddresses;
        this.b2bUnitId = userDataget?.res?.uid;
        this.orderBlock = userDataget?.res?.orderBlockFlag ? true : false;
        if (this.orderBlock) {
          this.showDangerAlert = true;
        }
        this.changeLocation = this.getuserData?.length <= 1 ? false : true;
        this.cdr.detectChanges();
      }
    });
  }

  onOptionsSelected(data) {
    this.listSelectedData = data;
  }

  onSubmit(): void {
    if (this.listSelectedData != undefined) {
      this.selectedData = this.listSelectedData;
      this.addToCart.saveLocation(this.selectedData?.uid,
        this.cartId, this.userAccountgetData?.uid);
      this.changedLocSub = this.addToCart.changedLocation$.subscribe((res) => {
        if (res) {
          this.addToCart.removedEntries(this.cartId, this.userAccountgetData?.uid);
          this.removeEntriesMapping();
        }
      });
    }
  }
  SearchClientName(data: any) {
    if (data.length > 0) {
      this.searchedClientList = this.getuserData.filter(x =>
        (x.companyName != undefined && x.companyName.toLowerCase().indexOf(data.toLowerCase()) >= 0)
        || (x.unitID != undefined && x.unitID.toLowerCase().indexOf(data.toLowerCase()) >= 0)
        || (x.line1 != undefined && x.line1.toLowerCase().indexOf(data.toLowerCase()) >= 0)
        || (x.line2 != undefined && x.line2.toLowerCase().indexOf(data.toLowerCase()) >= 0)
        || (x.town != undefined && x.town.toLowerCase().indexOf(data.toLowerCase()) >= 0)
        || (x.postalCode != undefined && x.postalCode.toLowerCase().indexOf(data.toLowerCase()) >= 0))

    }
    else {
      this.searchedClientList = this.getuserData;

    }
  }
  saveOrder(): void {
    var reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
    if (this.saveCartName && RegExp(reg).test(this.saveCartName)) {
      //this.addToCart.saveCartDetails(this.saveCartName, this.cartId, true);

      //checking the cartType
      let fluorderCounter = 0;

      for (let order of this.stdCartDetails?.orders) {
        let cartCode = order?.code;
        let cartType = order?.cartType;
        if (cartType?.toLowerCase() == 'standard') {
          this.cartId = cartCode;
          break;
        }
        else {
          fluorderCounter++;
        }
      }
      //if all orders are flu orders, dont call api.
      if (this.stdCartDetails?.orders?.length === fluorderCounter) {
        this.errorMsg = 'Flu Orders cannot be saved.';
        return;
      }

      this.addToCart.saveOrderDetails(this.saveCartName, this.cartId);
      this.saveCartInvalidSub = this.addToCart.invalidOrderName$.subscribe((res) => {
        if (res) {

          for (let error of res?.error?.errors) {
            this.errorMsg = error?.message;
          }
        }
      });
      this.saveCartSuccessSub = this.addToCart.saveOrderSuccess$.subscribe((res) => {
        if (res) {
          if (this.savePopover) {
            this.savePopover.close();
          }
          this.errorMsg = "";
          this.saveCartName = this.selectedData?.name?.slice(0, 30);
        }
      });
    } else {
      if (this.saveCartName) {
        this.errorMsg = "Save cart name is not valid.";
      } else {
        this.errorMsg = "Cart name cannot be blank.";
      }
    }
  }
  exportXls() {
    let cartProducts = [];
    for (let cartItem of this.stdCartDetails.orders) {
      for (let entries of cartItem.entries) {
        cartProducts.push({
          'Customer': cartItem.shipToLoc_id + ' ' + cartItem.shipToLoc_name,
          'Material': entries?.product?.code,
          'Quantity': entries?.quantity,
        })
      }
    }
    this.addToCart.downloadXls(cartProducts, 'OrderConfirmation');
  }
  omit_special_char(event) {
    this.errorMsg = "";
    var reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
    return new RegExp(reg).test(event.key);
  }
  setDeliveryDate() {
    this.minDeliveryDate.setDate(this.minDeliveryDate.getDate());
    if ((this.minDeliveryDate.getDay() === 0) || (this.minDeliveryDate.getDay() === 6)) {
      for (let i = 1; i <= 3; i++) {
        this.minDeliveryDate.setDate(this.minDeliveryDate.getDate() + 1);
        if ((this.minDeliveryDate.getDay() !== 0) && (this.minDeliveryDate.getDay() !== 6))
          break;
      }
    }
    this.maxDeliveryDate.setDate(this.minDeliveryDate.getDate() + (6));

    this.deliveryDate = this.minDeliveryDate;
  }
  setPickupDate() {
    if (this.currentTime < 12) {
      // Date Set
      this.minPickupDate.setDate(this.minPickupDate.getDate());
      if ((this.minPickupDate.getDay() === 0) || (this.minPickupDate.getDay() === 6)) {
        for (let i = 1; i <= 3; i++) {
          this.minPickupDate.setDate(this.minPickupDate.getDate() + 1);
          if ((this.minPickupDate.getDay() !== 0) && (this.minPickupDate.getDay() !== 6))
            break;
        }
      }
      this.maxPickupDate.setDate(this.minPickupDate.getDate() + (6));
    } else {
      this.minPickupDate.setDate(this.minPickupDate.getDate() + 1);
      if ((this.minPickupDate.getDay() === 0) || (this.minPickupDate.getDay() === 6)) {
        for (let i = 1; i <= 3; i++) {
          this.minPickupDate.setDate(this.minPickupDate.getDate() + 1);
          if ((this.minPickupDate.getDay() !== 0) && (this.minPickupDate.getDay() !== 6))
            break;
        }
      }
      this.maxPickupDate.setDate(this.minPickupDate.getDate() + (6));
    }
    this.pickupDate = this.minPickupDate;
  }
  setPickupTime() {
    if (this.currentTime < 10) {
      this.timeFormat = this.pickupTimeFormat.slice(3);
    } else if (this.currentTime === 10) {
      this.timeFormat = this.pickupTimeFormat.slice(4);
    } else if (this.currentTime === 11) {
      this.timeFormat = this.pickupTimeFormat.slice(6);
    } else if (this.currentTime > 11 && this.currentTime < 17) {
      this.timeFormat = this.pickupTimeFormat.slice(0);
    } else if (this.currentTime > 16) {
      this.timeFormat = this.pickupTimeFormat.slice(3);
    }
    this.selectedTime = _.first(this.timeFormat);
  }
  toggleAccordion(index: number) {
    this.expandedItems[index] = !this.expandedItems[index];
  }
  getExpandedItems(index: number): boolean {
    return this.expandedItems[index] || false;
  }
  getImage(images: any, imgFormat: string) {
    'thumbnail'
    const imagesFormat = _.clone(_.findWhere(images, { format: imgFormat }));
    let finalImageUrl: string;
    if (imagesFormat) {
      finalImageUrl = `${this.baseUrl}${imagesFormat?.url}`;
    }
    else {
      if (this.baseSiteId == 'vsh') {
        finalImageUrl = '../../assets/i18n-assets/sanofi_missing_product.jpg'
      } else {
        finalImageUrl = '../../assets/i18n-assets/sanofi_missing_product_vax.jpg'
      }
      //finalImageUrl = this.fallbackImage;
    }
    return finalImageUrl;
  }
  getTotalPrice(childCarts) {
    let totalPrice = 0;
    if (childCarts) {
      for (const orders of childCarts) {
        totalPrice += orders?.totalPrice.value;
      }
    }
    return totalPrice;
  }

  getTotalSaving(childCarts) {
    let totalSavingAmt = 0;
    if (childCarts) {
      childCarts.orders.forEach(el => {
        el.entries.forEach(ele => {
          totalSavingAmt += ele?.sim_other_discount?.value + ele?.sim_promptpay_Discount?.value + ele?.sim_site_discount?.value + ele?.webDiscount?.value;
        })
      })

    }
    return totalSavingAmt;
  }

  getQuantity(childCarts) {
    let quantity = 0;
    if (childCarts) {
      for (const carts of childCarts) {
        for (const entries of carts?.entries) {
          quantity += entries?.quantity;
        }
      }
    }
    return quantity;
  }

  navigateToPdp() {
    this.route.goByUrl('/Open-Catalogue/c/1');
  }

  ngOnDestroy() {
    this.prodAddedSub?.unsubscribe();
    this.cartItemsSub?.unsubscribe();
    this.removeEntriesSub?.unsubscribe();
    this.deleteCartSub?.unsubscribe();
    this.cartDetailsSub?.unsubscribe();
    this.checkoutDetailsSub?.unsubscribe();
    this.checkoutFailedSub?.unsubscribe();
    this.userAccountDetailsSub?.unsubscribe();
    this.changedLocSub?.unsubscribe();
    this.saveCartInvalidSub?.unsubscribe();
    this.saveCartSuccessSub?.unsubscribe();
    this.plpMiniCartSub?.unsubscribe();
    this.userDataSub?.unsubscribe();
    this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
    this.localSubscription.unsubscribe();
    this.checkoutCartDetailsSub?.unsubscribe();
    this.checkoutCartFailedSub?.unsubscribe();
  }

  isWeekDate(date): string {
    let shipImmediateFormat = moment.utc((new Date(date))).format('MM/DD/yyyy') + '<br>(Estimated)';
    let weekOfFormat = 'Week of\n' + moment.utc(new Date(date)).format('MM/DD/yyyy');
    if (localStorage.hasOwnProperty('shipImmediateDateFS') && localStorage.getItem('shipImmediateDateFS')) {
      if (moment.utc(new Date(date)).format('DD/MM/yyyy') == moment.utc(new Date(localStorage.getItem('shipImmediateDateFS'))).format('DD/MM/yyyy'))
        return shipImmediateFormat
      else
        return weekOfFormat;
    }
    else {
      return weekOfFormat;
    }
  }

  getQtyOrShipDate(index, date, quantityVal, action) {
    if (action === 'quantity') {
      if (index === 0) {
        return quantityVal;
      } else {
        return this.isWeekDate(date);
      }
    }
    else {
      if (index === 0) {
        return this.isWeekDate(date);
      }
      else {
        return '';
      }
    }
  }
}
